// SearchableDropdown.js - Unified searchable dropdown for single and multi-select

import React, { useState } from 'react';
import Select from 'react-select';
import { FixedSizeList as List } from 'react-window';
import { getSelectStyles } from './selectStyles';
import styles from './chat-templates.scss';

const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  fieldName,
  isLoading = false,
  isLightMode = false,
  isMulti = false,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(undefined);

  const selectOptions = options.map(opt => ({
    value: opt.value,
    label: opt.label
  }));

  // Handle both single and multi values
  const selectedValue = isMulti
    ? (Array.isArray(value) ? selectOptions.filter(opt => value.includes(opt.value)) : [])
    : (selectOptions.find(opt => opt.value === value) || null);

  const handleSelectAll = () => {
    onChange(selectOptions.map(opt => opt.value));
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const handleChange = (selected) => {
    if (isMulti) {
      onChange(selected ? selected.map(s => s.value) : []);
    } else {
      onChange(selected?.value || '');
    }
  };

  // Virtual scrolling menu list with optional Select All/Clear All
  const MenuList = (props) => {
    const { children, maxHeight } = props;
    const childrenArray = React.Children.toArray(children);
    const actionsHeight = isMulti ? 50 : 0;
    const listHeight = Math.min(maxHeight - actionsHeight, childrenArray.length * 35);

    return (
      <>
        {isMulti && (
          <div className={styles.multiSelectActions}>
            <button
              onClick={handleSelectAll}
              className={styles.selectAllBtn}
              type="button"
            >
              ✓ Select All ({selectOptions.length})
            </button>
            {Array.isArray(selectedValue) && selectedValue.length > 0 && (
              <button
                onClick={handleClearAll}
                className={styles.clearAllBtn}
                type="button"
              >
                ✕ Clear All
              </button>
            )}
          </div>
        )}

        <List
          height={Math.max(listHeight, 35)}
          itemCount={childrenArray.length}
          itemSize={35}
          width="100%"
        >
          {({ index, style }) => <div style={style}>{childrenArray[index]}</div>}
        </List>
      </>
    );
  };

  const customStyles = getSelectStyles(isLightMode);

  return (
    <Select
      options={selectOptions}
      value={selectedValue}
      onChange={handleChange}
      isMulti={isMulti}
      menuIsOpen={isMulti ? menuIsOpen : undefined}
      onMenuOpen={isMulti ? () => setMenuIsOpen(true) : undefined}
      onMenuClose={isMulti ? () => setMenuIsOpen(false) : undefined}
      closeMenuOnSelect={!isMulti}
      hideSelectedOptions={false}
      placeholder={placeholder || `Search ${fieldName}...`}
      isClearable
      isSearchable
      isLoading={isLoading}
      components={{ MenuList }}
      className={styles.searchableDropdown}
      classNamePrefix="select"
      styles={customStyles}
    />
  );
};

export default SearchableDropdown;
